module.exports = require("debug");


//////////////////
// WEBPACK FOOTER
// external "debug"
// module id = 0
// module chunks = 0 1